/**
 * Get whether the welcome/getting-started page should be hidden (i.e. the
 * user has already completed the onboarding form for this application).
 *
 * The canonical source of truth is the `welcomeAgreed` property on the
 * application object. Falls back to the legacy `basket.meta.started.welcomeAgreed`
 * value for backward compatibility during rollout.
 */

import { createSelector } from 'reselect';

import getApplicationSelector from '/business/shared/state/selectors/application/getApplicationSelector';
import { hasAgreedToWelcomeSelector } from '/business/shared/state/selectors/application/basket_meta/getBasketMetaSelector';

export default createSelector(
  [getApplicationSelector, hasAgreedToWelcomeSelector],
  (application, legacyWelcomeAgreed) => {
    if (application?.welcomeAgreed) {
      return true;
    }
    return !!legacyWelcomeAgreed;
  },
);
